export default "<span>{{maskedPhoneNumber}}</span>"